// Report Builder dictation always stays on Azure regardless of this flag.
export type LiveTranscriptionProvider = "azure" | "assemblyai";

export const LIVE_TRANSCRIPTION: {
  scribeProvider: LiveTranscriptionProvider;
  // Keep in sync with transcribe-summarize-api/assemblyai_transcribe.py.
  assemblyai: {
    speakerLabels: boolean;
    // Must match batch DIARIZATION_MEDICAL_MODE_ENABLED (transcribe-summarize-api).
    domain: "medical-v1" | null;
    // Opus bitrate for the recorded WebM sent to batch transcription; speech needs little.
    recorderAudioBitsPerSecond: number;
  };
} = {
  scribeProvider:
    import.meta.env.VITE_SCRIBE_PROVIDER === "assemblyai" ? "assemblyai" : "azure",
  assemblyai: {
    speakerLabels: true,
    domain:
      import.meta.env.VITE_SCRIBE_MEDICAL_MODE === "true" ? "medical-v1" : null,
    recorderAudioBitsPerSecond: 32000,
  },
};

export const isAssemblyAIScribe = (): boolean =>
  LIVE_TRANSCRIPTION.scribeProvider === "assemblyai";

// IndexedDB holding interrupted AssemblyAI sessions; wiped on logout.
export const ASSEMBLYAI_RECOVERY_DB_NAME = "medirect-assemblyai-recovery";
// IndexedDB holding interrupted Azure Scribe audio; wiped on logout.
export const SCRIBE_RECOVERY_DB_NAME = "medirect-scribe-recovery";
// Dictation transcripts were mirrored to this localStorage key by a crash-recovery
// snapshot that nothing ever read back (removed in MDRS-571). Cleared on logout so
// devices that already hold one don't keep clinical text past the session.
export const LEGACY_TRANSCRIPT_SNAPSHOT_KEY = "medirect.transcriber.recovery";
